import React from "react";
import { Badge } from "../../../ui";
import { getScoreBadgeVariant } from "../hooks/useEvaluationData";

interface InstanceHeaderProps {
  instanceName: string;
  instanceId: string;
  isRoot?: boolean;
  score?: number | null;
}

export function InstanceHeader({
  instanceName,
  instanceId,
  isRoot = false,
  score,
}: InstanceHeaderProps) {
  return (
    <div className="mb-3 flex items-center gap-2 flex-wrap">
      <h4 className="text-sm font-semibold text-muted-foreground">
        Instance: {instanceName}
      </h4>
      {isRoot && (
        <Badge variant="outline">
          Root
        </Badge>
      )}
      {score !== null && score !== undefined && (
        <Badge
          variant={getScoreBadgeVariant(score)}
          className="text-xs px-2 py-0.5"
        >
          Score: {score.toFixed(3)}
        </Badge>
      )}
      <span className="text-xs font-medium text-muted-foreground">
        ID: <code className="bg-muted px-2 py-0.5 rounded">{instanceId}</code>
      </span>
    </div>
  );
}
